const HomeActionType = {
  STORE_ADDRESS_AUTO_COMPLETE: 'HOME_STORE_ADDRESS_AUTO_COMPLETE',
  STORE_SELECTED_ADDRESS_PARTS: 'HOME_STORE_SELECTED_ADDRESS_PARTS',
  SET_LOADING_VISIBILITY: 'HOME_SET_LOADING_VISIBILITY',
  RESET_ADDRESS_SEARCH: 'HOME_RESET_ADDRESS_SEARCH',
  RESET_ALL: 'HOME_RESET_ALL',
  STORE_CONTRACT: 'HOME_STORE_CONTRACT',
  STORE_PLAN: 'HOME_STORE_PLAN',
  STORE_PARTNER: 'HOME_STORE_PARTNER',
  STORE_ERROR: 'HOME_STORE_ERROR'
};

export default HomeActionType;



/** WEBPACK FOOTER **
 ** ./src/common/HomeActionType.js
 **/